import { FC } from 'react';
import { Input} from '@features/ui';
import { Controller, UseFormReturn } from 'react-hook-form';
import { ProductFormData } from '@src/types';

export const ProductQualificationForm: FC<UseFormReturn<ProductFormData>> = ({
  control,
  formState: { errors },
}) => {
  return (
    <div
      className={
        'text-xs mb-[33px] border-dotted border-[#FFFFFF] border-t-[1.5px]'
      }
    >
      <div className={'mt-[12px] lg:ml-10 ml-5'}>
        <div className={'w-fit flex flex-col gap-[5px]'}>
          <p className={'text-[16px]'}>
            Qualification to become a Performance Account
          </p>
          <div className={'w-full h-[1px] bg-white'} />
        </div>
        <div
          className={
            'flex lg:flex-row flex-col lg:w-[100%] w-full mt-[30px] gap-x-[73px] gap-y-7'
          }
        >
          <Controller
            control={control}
            name="days_to_qualify"
            render={({ field }) => (
              <div className={'flex flex-1 flex-col gap-[14px]'}>
                <p>Days to Qualify</p>
                <Input
                  error={!!errors.days_to_qualify?.message}
                  placeholder={'Enter'}
                  textSize={'xs'}
                  type={'number'}
                  variant={'secondary'}
                  {...field}
                />
              </div>
            )}
          />
          <Controller
            control={control}
            name="profit_target"
            render={({ field }) => (
              <div className={'flex flex-1 flex-col gap-[14px]'}>
                <p>Profit Target $</p>
                <Input
                  className={'pl-2'}
                  error={!!errors.profit_target?.message}
                  placeholder={'Enter'}
                  startIcon={
                    <div
                      className={
                        'border-r border-white pr-[15px] h-[22px] flex items-center'
                      }
                    >
                      $
                    </div>
                  }
                  textSize={'xs'}
                  type={'number'}
                  variant={'secondary'}
                  {...field}
                />
              </div>
            )}
          />
          <div className={'lg:flex hidden flex-1'} />
        </div>
        {/*<div*/}
        {/*  className={*/}
        {/*    'flex lg:flex-row flex-col lg:w-[100%] w-full lg:mt-[45px] mt-7 gap-x-[71px] gap-y-7 items-start'*/}
        {/*  }*/}
        {/*>*/}
        {/*  <Controller*/}
        {/*    control={control}*/}
        {/*    name="fill_out_survey"*/}
        {/*    render={({ field }) => (*/}
        {/*      <div className={'flex flex-col gap-y-1.5'}>*/}
        {/*        <div*/}
        {/*          className={*/}
        {/*            'flex lg:flex-row flex-col flex-1 gap-[20px] lg:items-center'*/}
        {/*          }*/}
        {/*        >*/}
        {/*          <p>Fill out survey</p>*/}
        {/*          <RadioGroup*/}
        {/*            className={'flex gap-x-[26px]'}*/}
        {/*            value={*/}
        {/*              typeof field.value === 'boolean'*/}
        {/*                ? field.value*/}
        {/*                  ? YesOrNo.Yes*/}
        {/*                  : YesOrNo.No*/}
        {/*                : ''*/}
        {/*            }*/}
        {/*            onValueChange={(value) =>*/}
        {/*              field.onChange(value === YesOrNo.Yes)*/}
        {/*            }*/}
        {/*          >*/}
        {/*            {isBundleData.map((item) => {*/}
        {/*              return (*/}
        {/*                <div*/}
        {/*                  key={item.value}*/}
        {/*                  className={'flex items-center gap-x-[18px]'}*/}
        {/*                >*/}
        {/*                  <RadioGroupItem value={item.value} />*/}
        {/*                  <p>{item.label}</p>*/}
        {/*                </div>*/}
        {/*              );*/}
        {/*            })}*/}
        {/*          </RadioGroup>*/}
        {/*        </div>*/}
        {/*        <p className={'text-red-500'}>*/}
        {/*          {errors.fill_out_survey?.message}*/}
        {/*        </p>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*  />*/}
        {/*  <Controller*/}
        {/*    control={control}*/}
        {/*    name="survey_trigger_time"*/}
        {/*    render={({ field }) => (*/}
        {/*      <div className={'flex flex-col gap-y-1.5'}>*/}
        {/*        <div*/}
        {/*          className={*/}
        {/*            'flex lg:flex-row flex-col flex-2 gap-[17px] lg:items-center lg:mr-[71px]'*/}
        {/*          }*/}
        {/*        >*/}
        {/*          <p>When?</p>*/}
        {/*          <RadioGroup*/}
        {/*            className={'flex gap-x-[18px]'}*/}
        {/*            value={field.value}*/}
        {/*            onValueChange={(value) => field.onChange(value)}*/}
        {/*          >*/}
        {/*            {productSurveyTriggerTimeData.map((item) => {*/}
        {/*              return (*/}
        {/*                <div*/}
        {/*                  key={item.value}*/}
        {/*                  className={'flex items-center gap-x-[18px]'}*/}
        {/*                >*/}
        {/*                  <RadioGroupItem value={item.value} />*/}
        {/*                  <p>{item.label}</p>*/}
        {/*                </div>*/}
        {/*              );*/}
        {/*            })}*/}
        {/*          </RadioGroup>*/}
        {/*        </div>*/}
        {/*        <p className={'text-red-500'}>*/}
        {/*          {errors.survey_trigger_time?.message}*/}
        {/*        </p>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*  />*/}
        {/*</div>*/}
        {/*<div*/}
        {/*  className={*/}
        {/*    'flex lg:flex-row flex-col w-full lg:mt-[51px] mt-7 gap-x-[40px] gap-y-7 items-start'*/}
        {/*  }*/}
        {/*>*/}
        {/*  <Controller*/}
        {/*    control={control}*/}
        {/*    name="offer_reset_practice_account_phase"*/}
        {/*    render={({ field }) => (*/}
        {/*      <div className={'flex flex-col gap-y-1.5'}>*/}
        {/*        <div*/}
        {/*          className={*/}
        {/*            'flex lg:flex-row flex-col gap-[22px] lg:items-center'*/}
        {/*          }*/}
        {/*        >*/}
        {/*          <p>Offer Reset for practice account phase</p>*/}
        {/*          <RadioGroup*/}
        {/*            className={'flex gap-x-[33px]'}*/}
        {/*            value={*/}
        {/*              typeof field.value === 'boolean'*/}
        {/*                ? field.value*/}
        {/*                  ? YesOrNo.Yes*/}
        {/*                  : YesOrNo.No*/}
        {/*                : ''*/}
        {/*            }*/}
        {/*            onValueChange={(value) =>*/}
        {/*              field.onChange(value === YesOrNo.Yes)*/}
        {/*            }*/}
        {/*          >*/}
        {/*            {isBundleData.map((item) => {*/}
        {/*              return (*/}
        {/*                <div*/}
        {/*                  key={item.value}*/}
        {/*                  className={'flex items-center gap-x-[18px]'}*/}
        {/*                >*/}
        {/*                  <RadioGroupItem value={item.value} />*/}
        {/*                  <p>{item.label}</p>*/}
        {/*                </div>*/}
        {/*              );*/}
        {/*            })}*/}
        {/*          </RadioGroup>*/}
        {/*        </div>*/}
        {/*        <p className={'text-red-500'}>*/}
        {/*          {errors.offer_reset_practice_account_phase?.message}*/}
        {/*        </p>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*  />*/}
        {/*  <Controller*/}
        {/*    control={control}*/}
        {/*    name="offer_reset_performance_account_phase"*/}
        {/*    render={({ field }) => (*/}
        {/*      <div className={'flex flex-col gap-y-1.5'}>*/}
        {/*        <div*/}
        {/*          className={*/}
        {/*            'flex gap-[22px] lg:flex-row flex-col lg:items-center'*/}
        {/*          }*/}
        {/*        >*/}
        {/*          <p>Offer Reset for performance account phase</p>*/}
        {/*          <RadioGroup*/}
        {/*            className={'flex gap-x-[33px]'}*/}
        {/*            value={*/}
        {/*              typeof field.value === 'boolean'*/}
        {/*                ? field.value*/}
        {/*                  ? YesOrNo.Yes*/}
        {/*                  : YesOrNo.No*/}
        {/*                : ''*/}
        {/*            }*/}
        {/*            onValueChange={(value) =>*/}
        {/*              field.onChange(value === YesOrNo.Yes)*/}
        {/*            }*/}
        {/*          >*/}
        {/*            {isBundleData.map((item) => {*/}
        {/*              return (*/}
        {/*                <div*/}
        {/*                  key={item.value}*/}
        {/*                  className={'flex items-center gap-x-[18px]'}*/}
        {/*                >*/}
        {/*                  <RadioGroupItem value={item.value} />*/}
        {/*                  <p>{item.label}</p>*/}
        {/*                </div>*/}
        {/*              );*/}
        {/*            })}*/}
        {/*          </RadioGroup>*/}
        {/*        </div>*/}
        {/*        <p className={'text-red-500'}>*/}
        {/*          {errors.offer_reset_performance_account_phase?.message}*/}
        {/*        </p>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*  />*/}
        {/*</div>*/}
      </div>
    </div>
  );
};
